import { Link } from 'gatsby';
import uniqBy from 'lodash/uniqBy';
import { ChevronRight } from 'lucide-react';
import React from 'react';

import { Text, TextColor, TextVariant, TextWeight } from '../Text';
import { root } from './Breadcrumbs.module.scss';

type Crumb = {
  title: string;
  slug?: string;
};

type Props = {
  crumbs: Crumb[];
};

export const Breadcrumbs: React.FC<Props> = ({ crumbs }): JSX.Element => {
  return (
    <ul className={root}>
      <Text tag="li" variant={TextVariant.BODY_X_SMALL}>
        <Link to="/">Home</Link>
      </Text>

      {uniqBy(crumbs, 'title')
        .filter((crumb) => !!crumb.title)
        .map((crumb) => {
          const isLast = crumb === crumbs[crumbs.length - 1];
          return (
            <Text
              key={crumb.title}
              tag="li"
              variant={TextVariant.BODY_X_SMALL}
              weight={isLast ? TextWeight.BOLD : TextWeight.NORMAL}
              color={isLast && TextColor.BLACK}
            >
              <ChevronRight size={12} className="text-black-400" />

              {crumb.slug === undefined ? (
                crumb.title
              ) : (
                <Link to={crumb.slug}>{crumb.title}</Link>
              )}
            </Text>
          );
        })}
    </ul>
  );
};
